import { Box } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import SimpleBarScroll from "components/SimpleBar";
import ValidationAllocation from "pages/product_validation/validationAllocation/ValidationAllocation";
import React from "react";

const ValidationAllocationDialog = ({ open, handleClose, product }) => {
  return (
    <CustomDialog
      forceFullScreen={false}
      open={open}
      handleClose={handleClose}
      heading="Apply validation"
    >
      <Box sx={{ overflow: "hidden" }}>
        <SimpleBarScroll>
          <Box padding={2}>
            <ValidationAllocation product={product} fullGrid={true} />
          </Box>
        </SimpleBarScroll>
      </Box>
    </CustomDialog>
  );
};

export default ValidationAllocationDialog;
